// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewPayors-LoadingItem_cls1__9fHj3","cls2":"PaymentChannelViewPayors-LoadingItem_cls2__P-GHI PaymentChannelViewPayors-LoadingItem_cls1__9fHj3"};